"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtilsDrop = void 0;
const utilsSQLite_1 = require("./utilsSQLite");
class UtilsDrop {
    constructor() {
        this.sqliteUtil = new utilsSQLite_1.UtilsSQLite();
    }
    /**
     * DropElements
     * @param db
     * @param type ["table","index","trigger"]
     */
    async dropElements(db, type) {
        let msg = '';
        let stmt1 = `AND name NOT LIKE ('sqlite_%')`;
        switch (type) {
            case 'index':
                msg = 'DropIndexes';
                break;
            case 'trigger':
                msg = 'DropTriggers';
                break;
            case 'table':
                msg = 'DropTables';
                stmt1 += ` AND name NOT IN ('sync_table')`;
                break;
            case 'view':
                msg = 'DropViews';
                break;
            default:
                return Promise.reject(`DropElements: ${type} ` + 'not found');
        }
        // get the element's names
        let stmt = 'SELECT name FROM sqlite_master WHERE ';
        stmt += `type = '${type}' ${stmt1};`;
        try {
            const elements = await this.sqliteUtil.queryAll(db, stmt, []);
            if (elements.length > 0) {
                const upType = type.toUpperCase();
                const statements = [];
                for (const elem of elements) {
                    let stmt = `DROP ${upType} IF EXISTS `;
                    stmt += `${elem.name};`;
                    statements.push(stmt);
                }
                for (const stmt of statements) {
                    const lastId = await this.sqliteUtil.prepareRun(db, stmt, [], false);
                    if (lastId < 0) {
                        return Promise.reject(`${msg}: lastId < 0`);
                    }
                }
            }
            return Promise.resolve();
        }
        catch (err) {
            return Promise.reject(`${msg}: ${err}`);
        }
    }
    /**
     * DropAll
     * Drop all database's elements
     * @param db
     */
    async dropAll(db) {
        try {
            // drop tables
            await this.dropElements(db, 'table');
            // drop indexes
            await this.dropElements(db, 'index');
            // drop triggers
            await this.dropElements(db, 'trigger');
            // drop views
            await this.dropElements(db, 'view');
            // vacuum the database
            await this.sqliteUtil.prepareRun(db, 'VACUUM;', [], false);
            return Promise.resolve();
        }
        catch (err) {
            return Promise.reject(`DropAll: ${err}`);
        }
    }
    /**
     * DropTempTables
     * @param db
     * @param alterTables
     */
    async dropTempTables(db, alterTables) {
        const tempTables = Object.keys(alterTables);
        const statements = [];
        for (const tTable of tempTables) {
            let stmt = 'DROP TABLE IF EXISTS ';
            stmt += `_temp_${tTable};`;
            statements.push(stmt);
        }
        try {
            const changes = await this.sqliteUtil.execute(db, statements.join('\n'), false);
            if (changes < 0) {
                return Promise.reject('DropTempTables: changes < 0');
            }
            return Promise.resolve();
        }
        catch (err) {
            return Promise.reject(`DropTempTables: ${err}`);
        }
    }
}
exports.UtilsDrop = UtilsDrop;
//# sourceMappingURL=utilsDrop.js.map